const TypeGroupCustom = {
  USER: 'Associados',
  ADMIN: 'Administradores',
  CONSULT: 'Consultar',
  SUPPLIER: 'Fornecedores',
};

export default TypeGroupCustom;
